(() => {
  /* "Start chat" opens whichever chat widget the shop has installed. The
     button ships hidden and only appears once a provider is found: a button
     that visibly does nothing is worse than no button, and the email and phone
     below it are already working ways to get in touch. */

  /* Each provider is a pair: whether it is on the page, and how to open it.
     Testing for the object is the only reliable signal — calling an absent API
     through optional chaining returns undefined without throwing, so a bare
     call tells us nothing about whether anything happened. */
  const providers = [
    { present: () => window.ShopifyChat?.open, open: () => window.ShopifyChat.open() },
    { present: () => window.tidioChatApi?.open, open: () => window.tidioChatApi.open() },
    { present: () => window.$crisp?.push, open: () => window.$crisp.push(['do', 'chat:open']) },
    { present: () => typeof window.Intercom === 'function', open: () => window.Intercom('show') },
    { present: () => window.GorgiasChat?.open, open: () => window.GorgiasChat.open() },
    { present: () => window.Tawk_API?.maximize, open: () => window.Tawk_API.maximize() },
    { present: () => typeof window.zE === 'function', open: () => window.zE('messenger', 'open') },
  ];

  /* Last resort: click the widget's own launcher. Providers render it in an
     iframe more often than not, which we cannot reach into — hence the API
     calls above first. */
  const launcherSelectors = [
    '#shopify-chat',
    '.gorgias-chat-key-icon',
    '#tidio-chat',
    '.crisp-client',
    '#launcher',
  ];

  const tryOpen = () => {
    for (const provider of providers) {
      if (!provider.present()) continue;
      try {
        provider.open();
        return;
      } catch (error) {
        /* Present but not ready yet — fall through to the next one. */
      }
    }

    for (const selector of launcherSelectors) {
      const launcher = document.querySelector(selector);
      if (launcher) {
        launcher.click();
        return;
      }
    }
  };

  const hasProvider = () =>
    providers.some((provider) => provider.present()) ||
    Boolean(document.querySelector(launcherSelectors.join(',')));

  const init = (scope = document) => {
    const buttons = [...scope.querySelectorAll('[data-contact-chat]')];
    if (!buttons.length) return;

    /* Chat scripts load late and on their own schedule, so the page is polled
       for a little while rather than checked once. It gives up after ~15s —
       by then the widget is not coming. */
    let attempts = 0;
    const reveal = () => {
      attempts += 1;
      if (hasProvider()) {
        buttons.forEach((button) => {
          button.hidden = false;
        });
        return;
      }
      if (attempts < 30) window.setTimeout(reveal, 500);
    };
    reveal();

    buttons.forEach((button) => {
      button.addEventListener('click', tryOpen);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
